import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';

const CATEGORIES = [
  { value: 'general', label: '一般问题' },
  { value: 'bug', label: '问题反馈 / Bug' },
  { value: 'feature', label: '功能建议' },
  { value: 'job', label: '岗位相关' },
  { value: 'cooperation', label: '商务合作' },
  { value: 'other', label: '其他' },
];

function Feedback() {
  const { user } = useAuth();
  const [form, setForm] = useState({
    name: user?.displayName || '',
    email: user?.email || '',
    category: 'general',
    subject: '',
    content: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/feedback', form);
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.error || '提交失败，请稍后重试');
    }
    setLoading(false);
  };

  if (submitted) {
    return (
      <div className="container" style={{ maxWidth: 600, paddingTop: 80, textAlign: 'center' }}>
        <div className="card" style={{ padding: 48 }}>
          <div style={{ fontSize: '3rem', marginBottom: 16 }}>✅</div>
          <h2 style={{ marginBottom: 12 }}>感谢你的反馈！</h2>
          <p style={{ color: 'var(--text-secondary)', marginBottom: 24, lineHeight: 1.7 }}>
            我们已收到你的消息，会尽快回复到你提供的邮箱。<br />
            你的意见对我们非常重要！
          </p>
          <button className="btn btn-primary" onClick={() => { setSubmitted(false); setForm({ ...form, subject: '', content: '' }); }}>
            继续反馈
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container" style={{ maxWidth: 600, paddingTop: 20, paddingBottom: 60 }}>
      <div className="page-header">
        <h1 className="page-title">联系我们</h1>
        <p className="page-subtitle">有任何问题、建议或合作意向？随时联系我们</p>
      </div>

      {/* 直接联系方式 */}
      <div className="card" style={{ marginBottom: 24, background: 'var(--primary-light)' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
          <div style={{ fontSize: '1.5rem' }}>📬</div>
          <div>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>联系站长</div>
            <div style={{ fontSize: '0.9rem', color: 'var(--text-secondary)', lineHeight: 1.7 }}>
              通过下方表单留言，我们会尽快回复到你提供的邮箱。
            </div>
          </div>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="card">
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">你的称呼</label>
              <input className="form-input" name="name" value={form.name} onChange={handleChange} placeholder="怎么称呼你" />
            </div>
            <div className="form-group">
              <label className="form-label">邮箱 <span className="required">*</span></label>
              <input className="form-input" type="email" name="email" value={form.email} onChange={handleChange} placeholder="方便我们回复你" required />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">反馈类型</label>
            <select className="form-select" name="category" value={form.category} onChange={handleChange}>
              {CATEGORIES.map(c => (
                <option key={c.value} value={c.value}>{c.label}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">主题</label>
            <input className="form-input" name="subject" value={form.subject} onChange={handleChange} placeholder="简要描述你的问题或建议" />
          </div>

          <div className="form-group">
            <label className="form-label">详细内容 <span className="required">*</span></label>
            <textarea className="form-textarea" name="content" value={form.content} onChange={handleChange}
              placeholder="请详细描述你的问题、建议或想法..." required style={{ minHeight: 160 }} />
          </div>

          <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
            {loading ? '提交中...' : '提交反馈'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default Feedback;
